import { render, staticRenderFns } from "./SliderPaginator.vue?vue&type=template&id=0f63479c&scoped=true&"
import script from "./SliderPaginator.vue?vue&type=script&lang=js&"
export * from "./SliderPaginator.vue?vue&type=script&lang=js&"
import style0 from "./SliderPaginator.vue?vue&type=style&index=0&id=0f63479c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63479c",
  null
  
)

export default component.exports